import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import "primeicons/primeicons.css";
import { ApiEndpoints, Constants } from "../../../constants/appConstants";
import { useLocation, useSearchParams } from "react-router";
import httpService from "../../../services/httpService";
import { Dialog } from "primereact/dialog";
//import { useNavigate } from 'react-router';
import "./PfpProviderProfileComponent.scss";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import {
  alphaNumericSort,
  PerformanceArea,
  ReviewRquest,
  Standard,
  TierQuestions,
  Status,
  ReviewStatusCode,
  Comment,
  ReviewType,
  // TierCode,
  ProviderType,
  ReviewState
} from "./models";
import StandardsDetailsComponent from "./StandardsDetailsComponent";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useAuthContext } from "../../../Context/AuthContext";
import CommentsSidebar from "./CommentsSidebar";
import { useAppContext } from "../../../Context";
import MultipartFileUploadComponent from "../../FileUpload/MultpartFileUploadComponent";
import CommonDialogWindowComponent from "../../CommonDialogWindowComponent/CommonDialogWindowComponent";
import ReviewersDetailsComponent from "./ReviwersDetailsComponent";

const PfpScoProviderProfileComponent: React.FC = () => {
  //const navigate = useNavigate()

  const { appUser, isAdministrator, isFinalReviewer,isSmeReviewer } = useAuthContext();
  const [uploadStatus, setUploadStatus] = useState<string | null>(null);
  const location = useLocation();
  const [provider, setSelectedProvider] = useState<any>({});
  //const [providerDetails, setProviderDetails] = useState<any>({});
  const [performanceAreas, setPerformanceAreas] = useState<PerformanceArea[]>(
    []
  ); // New state to hold performance areas
  const [loading, setLoading] = useState<boolean>(false);
  const [fileUploaded, setFileUploaded] = useState<boolean>(false); // New state to track file upload status
  //const [activeIndex] = useState<number[]>([0, 1, 2]);
  const [status, setStatus] = useState<Status[]>([]);
  const [visible, setVisible] = useState(false);
  const [reviweResponses, setReviewResponses] = useState<ReviewRquest[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<
    Status | null | undefined
  >(null);
  const [isActiveReview, setIsActiveReview] = useState(false);
  const [isActiveDisputeReview, setIsActiveDisputeReview] = useState(false);
  const [appliedTierId, setAppliedTierId] = useState<number>(0);
  const [allStatues, setAllStatues] = useState<Status[]>([]);
  const [isStatusLoaded, setIsStatusLoaded] = useState<boolean>(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [commentProviderMPI, setCommentProviderMPI] = useState(
    location?.state?.provider?.mpi
  );
  const [commentMeasureNumber, setCommentMeasureNumber] = useState("");
  const [commentMeasureId, setCommentMeasureId] = useState(0);
  const [commentLevel, setCommentLevel] = useState("");
  const [providerId, setProviderId] = useState(0);
  const [allCommentData, setAllCommentData] = useState<Comment[]>([]);
  const { reviewYear } = useAppContext();
  const [searchParams] = useSearchParams();
  // const [providerAdditionalInfo, setProviderAdditionalInfo] = useState<any>({});
  const [statusesByRole, setStatusesByRole] = useState<any[]>([]);
  const [measureEvaluationStatuses, setMeasureEvaluationStatuses] = useState<any[]>([]);
  const [reviewers, setReviewers] = useState<any[]>([]);
  const [canReview, setCanReview] = useState<boolean>(false);
  const [canStartReview, setCanStartReview] = useState<boolean>(false);
  // const [incentiveMapping, setIncentiveMapping] = useState<any>([]);
  const [incentiveDetails, setIncentiveDetails] = useState<any>([]);
  // const [reasonDialogVisible, setReasonDialogVisible] = useState(false);
  // const [reviewReasons, setReviewReasons] = useState<any>([]);
  const [selectedReasonIds, setSelectedReasonIds] = useState<number[]>([]);
  const [userReason, setUserReason] = useState<string>("");
  const [selectedReviewResponseId, setSelectedReviewResponseId] = useState<number>();
  const [credentialingOutcomeStatus, setCredentialingOutcomeStatus] = useState<string | null>(null);
  const [technologyOutcomeStatus, setTechnologyOutcomeStatus] = useState<string | null>(null);
  const [resetApprovalStatus, setResetApprovalStatus] = useState<boolean>(false);
  // Reference variable for Dialog component
  const dialogRef = useRef<any>(null);

  // Fetch evaluation statuses on mount and when review status changes
  useEffect(() => {
    getMeasureEvaluationStatuses();
    return () => {
      if (dialogRef.current) {
        dialogRef.current = null;
      }
    };
  }, []);
  
  const getMeasureEvaluationStatuses = () => {
    httpService
      .get(`${ApiEndpoints.GetPfpMeasureEvaluationStatuses}?providerType=${ProviderType.SCO}`)
      .then((response: any) => {
        if (response.status === 200) {

          setMeasureEvaluationStatuses(response.data.filter((m: any) => m.code.toLowerCase() !== 'sme'));
          console.log("measureEvaluationStatuses:", measureEvaluationStatuses);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  }

  useEffect(() => {

    if (canReview && reviewers && reviewers.length > 0) {
      let canStart = false;
      if (
        provider &&
        ![
          ReviewStatusCode.ScoNotStarted?.toLowerCase(),
          ReviewStatusCode.NotStarted?.toLowerCase(),
          ReviewStatusCode.ScoPfpResolutionNotStarted?.toLowerCase()
        ].includes(provider.reviewStatusCode?.toLowerCase()) &&
        reviewers?.length > 0 && statusesByRole.map((s: any) => s?.toLowerCase()).includes(provider.reviewStatusCode?.toLowerCase())
      ) {
        canStart = reviewers.some(
          (r: any) =>
            r.reviewStatusCode?.toLowerCase() === provider.reviewStatusCode?.toLowerCase() &&
            (!r.reviewState || r.reviewState?.toLowerCase() === ReviewState.NOTSTART?.toLowerCase())
        );
      }

      setCanStartReview(canStart);
      const finalRev = isActiveDisputeReview?ReviewStatusCode.ScoPfpResolutionFinalReview?.toLowerCase():ReviewStatusCode.ScoFinalReview?.toLowerCase()
      setResetApprovalStatus(reviewers.some(
          (r: any) =>
            r.reviewStatusCode?.toLowerCase() === finalRev &&
            (r.reviewState?.toLowerCase() === ReviewState.INPROGRESS?.toLowerCase()
           || r.reviewState?.toLowerCase() === ReviewState.COMPLETED?.toLowerCase())
        ));
    }
  }, [provider, canReview, reviewers]);

  // Initialize provider from location
  useEffect(() => {
    const mpiId = searchParams.get('mpi');
    if (reviewYear && !mpiId) {
      const _provider = location.state?.provider;
      if (_provider) {
        console.log("Provider:", _provider);
        getProviderIncentiveDetails(_provider?.mpi.toString());
        fetchProviderDetails(_provider?.mpi);
        fetchAllCommentsForProvider(_provider?.mpi);
        setProviderId(_provider?.providerId);
        setCommentProviderMPI(_provider?.mpi);
        setCommentMeasureNumber(_provider?.mpi);
        //getProviderAdditionalInfo(_provider?.mpi);
        // getPfpIncentiveMapping(_provider?.mpi);
        setCommentMeasureId(0);
        setCommentLevel("provider");
        fetchStatusesByUser();
        getReviewersDetails(_provider?.mpi);
        canHaveAccessToReview(_provider?.mpi);
        //fetchProviderAttestationFileDetails(_provider?.mpi);
        // fetchPerformanceStandardsMeasuresInfo(
        //   _provider?.mpi,
        //   _provider?.appliedTier
        // );
      } // Fetch performance areas and related data
    }
  }, [location.state?.provider, reviewYear]);

  useEffect(() => {
    const mpiId = searchParams.get('mpi');

    if (reviewYear && mpiId) {
      const mpi = String(mpiId);
      getProviderIncentiveDetails(mpi.toString());
      fetchProviderDetails(mpi);
      fetchAllCommentsForProvider(mpiId);
      setCommentProviderMPI(mpi);
      setCommentMeasureNumber(mpiId);
      setCommentMeasureId(0);
      fetchStatusesByUser();
      setCommentLevel("provider");
      canHaveAccessToReview(mpiId);
      getReviewersDetails(mpiId);
      //fetchProviderAttestationFileDetails(_provider?.mpi);

    } // Fetch performance areas and related data
  }, [reviewYear]);

  const fetchStatusesByUser = () => {
    httpService
      .get(`${ApiEndpoints.GetPfpStatusesByRole}?providerType=${ProviderType.SCO}`)
      .then((response: any) => {
        if (response.status === 200) {
          setStatusesByRole(response.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
  }

  useEffect(() => {
    if (provider && provider.providerId) {
      setProviderId(provider?.providerId);

      fetchPerformanceStandardsMeasuresInfo(
        provider?.mpi,
        provider?.appliedTier
      );
    }
  }, [provider.providerId, provider.mpi, provider.appliedTier]);

  //onload events

  useEffect(() => {
    isActiveReviewCycle();
    isActiveDisputeReviewCycle();
    getAllStatus();
  }, []);


  useEffect(() => {
    if (provider.providerId && isStatusLoaded && !isActiveDisputeReview) {
      updateStatusDropDown();
      setSelectedStatus(getSelectedStatus(provider.reviewStatus));
    }
    else if(provider.providerId && isStatusLoaded && isActiveDisputeReview){
      updateStatusDropDownForDispute();
      setSelectedStatus(getSelectedStatus(provider.reviewStatus));
    }
  }, [provider, isStatusLoaded,isActiveDisputeReview]);

  //ODP-2797
  useEffect(() => {
    if (providerId > 0) {
      updatePerformanceAreasForComments(0, true);
    }
  }, [performanceAreas,providerId]);

  useEffect(() => {
    if (allStatues && allStatues.length > 0 && status && status.length > 0) {
      handleRequiredStatusOption();
    }
  }, [performanceAreas.length]); // Only re-run when performanceAreas change not on every render

  // const onReasonChange = (e: CheckboxChangeEvent) => {
  //   let _selectedReasonIds = [...selectedReasonIds];

  //   if (e.checked)
  //     _selectedReasonIds.push(e.target.value);
  //   else
  //     _selectedReasonIds = _selectedReasonIds.filter(reasonId => reasonId !== e.target.value);

  //   setSelectedReasonIds(_selectedReasonIds);
  // }
  // const getPfpIncentiveMapping = (providerMpi: string) => {
  //   httpService
  //     .get(
  //       `${ApiEndpoints.GetIncentiveMappingInfo
  //       }/${providerMpi}/${reviewYear}/${localStorage.getItem("providerType")}`
  //     )
  //     .then((response: any) => {
  //       console.log("getPfpIncentiveMapping", response);
  //       if (response.status === 200) {
  //         setIncentiveMapping(response.data.value);
  //       }
  //     })
  //     .catch((error: any) => {
  //       console.log("Error: ", error);
  //     });
  // };

    const isActiveDisputeReviewCycle = () => {
    httpService
      .get(ApiEndpoints.IsPfpActiveDisputeCycle)
      .then((response: any) => {
        setIsActiveDisputeReview(response?.data);
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
    };

  const getProviderIncentiveDetails = (providerMpi: string) => {
    httpService
      .get(
        `${ApiEndpoints.GetCalculatedIncentiveInfo
        }/${providerMpi}/${reviewYear}/${ProviderType.SCO}`
      )
      .then((response: any) => {
        console.log("getProviderIncentiveDetails", response);
        if (response.status === 200) {
          setIncentiveDetails(response.data.value);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  const canHaveAccessToReview = (mpi: string) => {
    if (!mpi) {
      return;
    }
    httpService
      .get(`${ApiEndpoints.PfpCanHaveAccessToReview}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setCanReview(response.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  }

  const getReviewersDetails = (mpi: string) => {
    if (!mpi) {
      return;
    }
    httpService
      .get(`${ApiEndpoints.GetPfpReviewersDetailsByMpi}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setReviewers(response.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  }



  const updatePerformanceAreasForComments = (
    measureId: number,
    isCommentsLoaded: boolean = false
  ) => {
    if (performanceAreas.length > 0 && measureId > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === Constants.CredentialingTypeId) {
                setCredentialingOutcomeStatus(measure.reviewResponse === null || measure.reviewResponse === "null" ? 'Unassigned' : (measure.reviewResponse?.toLocaleLowerCase() === 'a' ? 'Pass' : "Fail"))
              }
              if (measure.measureId === Constants.TechnologyTypeId) {
                setTechnologyOutcomeStatus(measure.reviewResponse === null || measure.reviewResponse === "null" ? 'Unassigned' : (measure.reviewResponse?.toLocaleLowerCase() === 'a' ? 'Pass' : "Fail"))
              }
              if (measure.measureId === measureId) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true};
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    } else if (isCommentsLoaded) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === Constants.CredentialingTypeId) {
                setCredentialingOutcomeStatus(measure.reviewResponse === null || measure.reviewResponse === "null" ? 'Unassigned' : (measure.reviewResponse?.toLocaleLowerCase() === 'a' ? 'Pass' : "Fail"))
              }
              if (measure.measureId === Constants.TechnologyTypeId) {
                setTechnologyOutcomeStatus(measure.reviewResponse === null || measure.reviewResponse === "null" ? 'Unassigned' : (measure.reviewResponse?.toLocaleLowerCase() === 'a' ? 'Pass' : "Fail"))
              }
              if (
                allCommentData.some((x) => x.measureId == measure.measureId)
              ) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  const isActiveReviewCycle = () => {
    httpService
      .get(ApiEndpoints.IsPfpActiveReview)
      .then((response: any) => {
        setIsActiveReview(response?.data);
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  // const hasAnySMEReviewForMeasure = (): boolean => {
  //   return performanceAreas.some((area) =>
  //     area.standards.some((standard) =>
  //       standard.measures.some(
  //         (measure) =>
  //           measure.reviewResponse &&
  //           measure.reviewResponse.toLowerCase() === "sme"
  //       )
  //     )
  //   );
  // }

  const isReadOnlyForFinalReviewer = () => {
    const finalStatus = isActiveDisputeReview ?ReviewStatusCode.ScoPfpResolutionReviewCompleted.toLowerCase():ReviewStatusCode.ScoReviewCompleted.toLowerCase();
    return (provider.reviewStatusCode?.toLowerCase() === finalStatus)  && (isFinalReviewer()||isSmeReviewer()) //add check for SME as well as it act like final Reviewer
  }

  const canDisableStatusRelatedInputs = () => {
    const hasValidStatus = selectedStatus &&
      statusesByRole.some(
        (s) =>
          s?.toLowerCase() ==
          selectedStatus.statusCode?.toLowerCase()
      )
    return !canReview || canStartReview || !hasValidStatus
  };
  // Fetch files and provider details once provider is set

  const updateStatusDropDown = () => {
    let requiredStatuses: Status[];
    if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.NotStarted?.toLowerCase() ||
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoNotStarted?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoNotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoInitialReview.toLowerCase()
      );
    }
    else if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoInitialReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoInitialReview.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoFinalReview.toLowerCase()
      );
    }
    else if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoSMEReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoSMEReview.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoFinalReview.toLowerCase()
      );
    }
    else if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoFinalReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoFinalReview.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    }
    // if (hasUnReviewedMeasures()) {
    //   requiredStatuses = requiredStatuses.filter(
    //     (s) => s.statusCode?.toLowerCase() !== ReviewStatusCode.ScoReviewCompleted.toLowerCase()
    //   );
    // }

    setStatus(requiredStatuses);
    return requiredStatuses;
  };

    const updateStatusDropDownForDispute = () => {
    let requiredStatuses: Status[];
    if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionNotStarted?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionNotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionInitialReview.toLowerCase()
      );
    }
    else if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionInitialReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionInitialReview.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionFinalReview.toLowerCase()
      );
    }
    else if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionSMEReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionSMEReview.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionFinalReview.toLowerCase()
      );
    }
    else if (
      provider.reviewStatusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionFinalReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionFinalReview.toLowerCase() ||
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() === ReviewStatusCode.ScoPfpResolutionReviewCompleted.toLowerCase()
      );
    }
    // if (hasUnReviewedMeasures()) {
    //   requiredStatuses = requiredStatuses.filter(
    //     (s) => s.statusCode?.toLowerCase() !== ReviewStatusCode.ScoReviewCompleted.toLowerCase()
    //   );
    // }

    setStatus(requiredStatuses);
    return requiredStatuses;
  };
  const getAllStatus = () => {
    httpService
      .get<Status[]>(`${ApiEndpoints.GetPfpReviewStatus}?providerType=${Constants.SCOKey}`)
      .then((response) => {
        setAllStatues(response.data);
        setIsStatusLoaded(true);
      })
      .catch((error) => {
        console.error("Error fetching tiers:", error);
      });
  };

  const updateStatus = (e: Status) => {
    httpService
      .post(ApiEndpoints.SetPfpReviewStatus, {
        ProviderId: provider.providerId,
        StatusId: e.statusId,
        reviewerName: appUser?.name ?? appUser?.email,
        ReviewYear: reviewYear,
        MpiId: provider.mpi,
        providerType: ProviderType.SCO
      })
      .then((response: any) => {
        if (response.status === 200) {
          setSelectedStatus(e);
          //setProviderDetails({ ...provider, reviewStatus: e.statusName })
          console.log("allStatues:", allStatues);
          getReviewersDetails(provider.mpi)
          let currentReviewType =
            e.statusCode.toUpperCase() === ReviewStatusCode.InPrimaryReview
              ? ReviewType.PrimaryReview
              : e.statusCode.toUpperCase() === ReviewStatusCode.InPeerReview
                ? ReviewType.SecondaryReview
                : provider.reviewType;

          setSelectedProvider({
            ...provider,
            reviewStatusCode: e.statusCode,
            reviewStatus: e.statusName,
            reviewStatusId: e.statusId,
            reviewType: currentReviewType,
          });
          ////Commented because now we are generating the decision letter from backend when provider review status is completed
          // if (e.statusCode.toLowerCase() === ReviewStatusCode.ScoReviewCompleted.toLowerCase()) {
          //   getDecisionLetter(provider.mpi);
          // }

          // Invoking ReviewStatusSync in Intake Portal - configurable via environment variable
          // if (Constants.IS_REALTIME_REVIEW_STATUS_SYNC_ENABLED) {
          //   syncReviewStatusInIntakePortal(e.statusId);
          // }
        }
      });
  }

  const setReviewStatus = (e: Status) => {
    const getStatusChangeAlertConfig = (e: any) => {

      let commonConfig = {
        open: true,
        title: "Confirm Status Change",
        message: `Are you sure you want to change the status to "${e.statusName}"?`,
        onClose: (result: boolean) => {
          if (result) {
            updateStatus(e);
          }
          dialogRef.current.setDialogConfig(undefined);
        },
      };
      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoFinalReview.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoPfpResolutionFinalReview.toLowerCase()
      ) {

        if (hasUnReviewedMeasures()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "Review Pending",
            message: "All initiatives must be reviewed before moving to Final Review and add the comments.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }

      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoReviewCompleted.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoPfpResolutionReviewCompleted.toLowerCase()
      ) {
        if (hasUnReviewedMeasures()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: hasUnReviewedMeasures()
              ? "Unreviewed Measures Present"
              : "Unassigned Tier",
            message: hasUnReviewedMeasures()
              ? "There are some unreviewed measures, so you cannot mark this as review complete."
              : `You cannot change the status to "${e.statusName}" while the provider is in the Unassigned tier.`,
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }
      return commonConfig;
    }

    if (dialogRef.current) {
      let config = getStatusChangeAlertConfig(e);
      dialogRef.current.setDialogConfig(config);
    }
  };

  // const syncReviewStatusInIntakePortal = (statusId: any) => {
  //   httpService
  //     .post(ApiEndpoints.SyncProviderStatusWithIntake, {
  //       ProviderId: provider.providerId,
  //       StatusId: statusId,
  //       reviewerEmail: appUser?.email ?? appUser?.name,
  //       MpiId: provider.mpi,
  //     })
  //     .then((response: any) => {
  //       if (response.status === 200) {
  //         console.log("allStatues:", allStatues);
  //         console.log("syncReviewStatusInIntakePortal Response:", response);
  //       }
  //     });
  // };

  // Fetch file information after file is uploaded
  useEffect(() => {
    if (fileUploaded) {
      //fetchSupportingFileInfo();
      setFileUploaded(false); // Reset after fetching
    }
  }, [fileUploaded]); // Triggers when a file is uploaded

  const fetchProviderDetails = async (mpi: string) => {
    httpService
      .get(`${ApiEndpoints.GetPFPProviderDetails}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        let _provider = response.data;
        console.log("Provider:", _provider);
        setSelectedProvider(_provider);
        setSelectedStatus(getSelectedStatus(_provider.reviewStatus));
        console.log("Stat:", _provider.reviewStatus)
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
      .finally(() => {
        // console.log('Finally');
      });
  };

  const getSelectedStatus = (statusName: string) => {
    if (allStatues && allStatues.length > 0) {
      return allStatues.find(status => status.statusName?.toLowerCase() === statusName.toLowerCase()) || null

    }
    return undefined;
  }



  const fetchAllCommentsForProvider = async (providerId: string) => {
    httpService
      .post(ApiEndpoints.GetAllPfpCommentsForProvider, {
        commentLevel: commentLevel,
        providerMPI: providerId,
        measureId: commentMeasureId,
        reviewYear: reviewYear,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setAllCommentData(response?.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
      .finally(() => {
        // console.log('Finally');
      });
  };
  const updatePerformanceAreasStatus = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string | null;
    reasons: any[];
    userReason: string;
  }) => {
    if (performanceAreas.length > 0) {
     setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === response.measureId) {
                if (!response.questionId) {
                  // Update measure.isApproved
                  return { ...measure, reviewResponse: response.reviewResponse,
                    hasReasons:
                      (response.reasons && response.reasons.length > 0) ||
                      !!response.userReason,
                   };
                } else {
                  // Update question.isReviewed
                  return {
                    ...measure,
                    questions: measure.questions.map((question) =>
                      question.questionId === response.questionId
                        ? {
                            ...question,
                            reviewResponse: response.reviewResponse,
                          }
                        : question
                    ),
                  };
                }
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  // handling tier response submission
  const onReviewChange = (response: {
    reviewResponseId: number;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string;
    reasons: any[],
    userReason: string
  }) => {
    updatePerformanceAreasStatus(response);
    let reviewResponse = reviweResponses.find(
      (resp) =>
        resp.incentiveTypeId === response.measureId &&
        resp.questionId === response.questionId
    );

    //handling the response data
    if (reviewResponse) {
      reviewResponse.reviewResponse = response.reviewResponse;
      reviewResponse.reasons = response.reasons;
      reviewResponse.userReason = response.userReason;
    } else {
      const name = appUser?.name;
      reviweResponses.push({
        tierId: performanceAreas[0].standards[0].tierId,
        reviewResponseId: response.reviewResponseId,
        mpiId: provider.mpi,
        incentiveTypeId: response.measureId,
        questionId: response.questionId,
        reviewResponse: response.reviewResponse,
        reasons: response.reasons,
        userReason: response.userReason,
        reviewerName: name
      });
    }
    const requiredData = reviweResponses; //.filter(resp => resp.isApproved || resp.reviewResponseId);
    setReviewResponses(requiredData);
    setSelectedReviewResponseId(response.reviewResponseId);
    // if (response.reviewResponse == 'na') {
    //   setSelectedReviewResponseId(response.reviewResponseId);
    //   setReasonDialogVisible(true);
    //   return;
    // }
    saveReviewResponses();
  };

  const handleRequiredStatusOption = () => {
    let requiredStatuses = isActiveDisputeReview?updateStatusDropDownForDispute():updateStatusDropDown();
    const smeStatusCode = isActiveDisputeReview ?ReviewStatusCode.ScoPfpResolutionSMEReview.toLowerCase():ReviewStatusCode.ScoSMEReview.toLowerCase();
    const RevDoneStatusCode = isActiveDisputeReview ?ReviewStatusCode.ScoPfpResolutionReviewCompleted.toLowerCase():ReviewStatusCode.ScoReviewCompleted.toLowerCase();
    //const hasSMEReview = hasAnySMEReviewForMeasure();

    // if (hasSMEReview) {
    //   if (!requiredStatuses.some(s => s.statusCode?.toLowerCase() === smeStatusCode)) {
    //     const smeStatus = allStatues.find(s => s.statusCode?.toLowerCase() === smeStatusCode);
    //     if (smeStatus) requiredStatuses.push(smeStatus);
    //   }
    // }
    // else 
    if (hasUnReviewedMeasures()) {
      requiredStatuses = requiredStatuses.filter(s => s.statusCode?.toLowerCase() !== RevDoneStatusCode);
    } else {
      requiredStatuses = requiredStatuses.filter(s => s.statusCode?.toLowerCase() !== smeStatusCode);
    }

    setStatus(requiredStatuses);
  };

  // Updating the reviewResponse for failed reasons
  useEffect(() => {
    if (selectedReviewResponseId) {
      setReviewResponses(prevResponses =>
        prevResponses.map(item =>
          item.reviewResponseId === selectedReviewResponseId
            ? {
              ...item,
              reasons: selectedReasonIds,
              userReason: userReason
            }
            : item
        )
      );
    }
  }, [selectedReasonIds, userReason]); // Triggers when a file is uploaded

  // const saveFailedReviewResponse = () => {
  //   // updating the state for specific reviewResponseId

  //   saveReviewResponses()
  // }

  const saveReviewResponses = () => {
    httpService
      .post(
        `${ApiEndpoints.SavePfpPerformanceEvaluation}/${appliedTierId}/${provider.mpi}`,
        reviweResponses,

      )
      .then((response) => {
        console.log("Review Response submitted successfully:", response);
        //handleSMEReviewAutoFlipToFinalReview();
        setUserReason("");
        setSelectedReasonIds([]);        
      })
      .catch((error) => {
        console.error("Error submitting review response:", error);
      });

    // if (reasonDialogVisible) {
    //   setReasonDialogVisible(false);
    // }
  };


  const getFilenameFromContentDisposition = (contentDisposition: string) => {
    if (!contentDisposition) {
      return "";
    }
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i
    );
    if (matches && matches[1]) {
      const decoded = decodeURIComponent(matches[1]);
      // Strip path separators and characters dangerous in HTML attributes;
      // control chars (charCode 0-31) removed via charCodeAt to avoid no-control-regex lint rule
      return decoded
        .replace(/[/\\?%*:|"<>]/g, "")
        .split("")
        .filter((c) => c.charCodeAt(0) > 31)
        .join("")
        .trim();
    }
    return "";
  };

  const downLoadProviderDataByDataSource = (dataSource: string) => {
    const safeMpi = String(provider.mpi);
    if (!safeMpi || isNaN(Number(safeMpi)) || Number(safeMpi) <= 0) {
      console.error("Invalid MPI value");
      return;
    }
    httpService
      .getBlob(
        `${ApiEndpoints.ExtractDataByDataSource}/${safeMpi}/${encodeURIComponent(dataSource)}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition =
          response.headers["content-disposition"] ?? "";
        link.setAttribute(
          "download",
          getFilenameFromContentDisposition(contentDisposition)
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error: any) => {
        setShowConfirmDialog(true);
        console.error("Error downloading provider data:", error);
      });
  };

  // Fetch performance areas, standards, measures, questions, and documents
  const fetchPerformanceStandardsMeasuresInfo = async (
    mpiId: number,
    providerAppliedTier: string
  ) => {
    try {
      if (!mpiId || !providerAppliedTier) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const performanceAreaUrl = isActiveDisputeReview?ApiEndpoints.GetAllPfpPerformanceStandardsMeasuresDisputeInfo:ApiEndpoints.GetAllPfpPerformanceStandardsMeasuresInfo
      const response = await httpService.get<PerformanceArea[]>(
        `${performanceAreaUrl}/${reviewYear}/${mpiId}?tierName=${providerAppliedTier}`
      );      
      let tierData = groupDataByTier(response.data);
      tierData = tierData.map(tier => ({
        ...tier,
        performanceAreas: tier.performanceAreas.map(area => ({
          ...area,
          standards: area.standards.map(standard => ({
            ...standard,
            measures: standard.measures.map(measure => ({
              ...measure,
            }))
          }))
        }))
      }));
      let activeTierData = tierData.filter(
        (tier) =>
          tier.tierName?.toLowerCase() === providerAppliedTier?.toLowerCase()
      )[0];
      setPerformanceAreas(activeTierData.performanceAreas);
      setAppliedTierId(activeTierData.tierId);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching performance area info:", error);
      setLoading(false);
    }
  };

  const groupDataByTier = (data: any[]): TierQuestions[] => {
    // Object.create(null) prevents prototype pollution via __proto__ / constructor keys
    const tierMap: { [key: number]: TierQuestions } = Object.create(null);
    data.forEach((item) => {
      const {
        tierId,
        tierName,
        performanceAreaId,
        performanceAreaTitle,
        performanceAreaDescription,
        standardId,
        standardTitle,
        standardDescription,
        measureId,
        measureTitle,
        measureDescription,
        measureNumber,
        reviewResponse,
        hasReason,
        reviewResponseId,
        isCalculatedField,
        questionId,
        questionTitle,
        questionDescription,
        isReviewed,
        fieldName,
        fieldValue,
        dataFieldType,
        dataSource,
        hasValidThreshold,
        questionSequence,
        questionNumber,
        propertySequence,
        displayConfig,
        comment,
        attachments
      } = item;

      // Validate tierId is a safe positive integer to prevent prototype pollution
      const safeTierId = Number(tierId);
      if (!Number.isFinite(safeTierId) || !Number.isInteger(safeTierId) || safeTierId <= 0) return;

      // If the tier doesn't exist, create it
      if (!tierMap[safeTierId]) {
        tierMap[safeTierId] = {
          tierId: safeTierId,
          tierName,
          performanceAreas: [],
        };
      }
      //
      // Add performance area to the tier
      if (!tierMap[safeTierId].performanceAreas) {
        tierMap[safeTierId].performanceAreas = [];
      }

      let performanceArea = tierMap[safeTierId].performanceAreas.find(
        (pa) => pa.performanceAreaId === performanceAreaId
      );
      if (!performanceArea) {
        performanceArea = {
          performanceAreaId,
          performanceAreaTitle,
          performanceAreaDescription,
          standards: [],
        };
        tierMap[safeTierId].performanceAreas.push(performanceArea);
      }

      // Add standard to the performance area
      let standard = performanceArea.standards.find(
        (s) => s.standardId === standardId
      );
      if (!standard) {
        standard = {
          standardId,
          standardTitle,
          standardDescription,
          isLocationSpecific: item.isLocationSpecific,
          tierId: safeTierId,
          tierName,
          measures: [],
        };
        performanceArea.standards.push(standard);
      }

      // Add measure to the standard
      let measure = standard.measures.find((m) => m.measureId == measureId);
      if (!measure) {
        const commentAvailable =
          allCommentData.filter((c) => c.measureId === measureId).length > 0;
        measure = {
          measureId,
          measureTitle,
          measureDescription,
          measureNumber,
          reviewResponse,
          hasReasons: hasReason,
          reviewResponseId: reviewResponse ? reviewResponseId : null,
          questions: [],
          isCommentsAvailable: commentAvailable,
        };
        standard.measures.push(measure);
      }

      let question = measure.questions.find((q) => q.questionId === questionId);
      if (!question) {
        question = {
          questionId,
          questionTitle,
          questionDescription,
          questionSequence: questionSequence,
          questionNumber: questionNumber,
          dataFieldType,
          isReviewed,
          dataSource,
          reviewResponseId: isReviewed ? reviewResponseId : null,
          isCalculatedField,
          displayConfig: displayConfig
            ? JSON.parse(displayConfig)
            : displayConfig,
          responseData: [],
          comment,
          attachments:attachments?JSON.parse(attachments):attachments,
        };

        measure.questions.push(question);
      }

      question.responseData.push({
        fieldName,
        fieldValue,
        hasValidThreshold,
        propertySequence,
      });
    });
    return Object.values(tierMap);
  };

  const canDisable = () => {
     return (
      isAdministrator() ||
      selectedStatus?.statusCode?.toLowerCase() ==
      ReviewStatusCode.NotStarted?.toLowerCase() ||
      selectedStatus?.statusCode?.toLowerCase() ==
      ReviewStatusCode.ScoNotStarted?.toLowerCase() ||
      provider?.reviewStatusId == 0 ||
      selectedStatus?.statusCode?.toLowerCase() ==
      ReviewStatusCode.ScoReviewCompleted?.toLowerCase()
      ||
       selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoPfpResolutionReviewCompleted?.toLowerCase() ||
        selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoPfpResolutionNotStarted?.toLowerCase() ||
      canDisableStatusRelatedInputs()
    );
  };


  const hasUnReviewedMeasures = (): boolean => {
    const hasunreviewedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter((measure) => measure.reviewResponse === null || measure.reviewResponse.toLowerCase() === 'null' || measure.reviewResponse.toLowerCase() === 'sme').length
          );
        }, 0)
      );
    }, 0);
    return hasunreviewedMeasures > 0;
  };

  const renderStandardsSection = (standards: Standard[],
    performanceAreaId: number
  ) => {
    var amount = incentiveDetails
      ? incentiveDetails.filter(
        (x: any) => x.incentiveTypeId == performanceAreaId
      )[0]?.calculatedIncentive
      : 0;
    // var currencySymbol = incentiveDetails
    //   ? incentiveDetails.filter(
    //     (x: any) => x.incentiveTypeId == performanceAreaId
    //   )[0]?.currencySymbol
    //   : "";
    var initiativeAmount = Number(Number(amount).toFixed(2));
    return (
      <>
        {[...(standards || [])]
          .sort((a, b) => a?.standardTitle.localeCompare(b?.standardTitle))
          .map((standard: Standard) => (
            <StandardsDetailsComponent
              downLoadProviderDataByDataSource={
                downLoadProviderDataByDataSource
              }
              key={`${standard.standardId}-${isActiveReview && !canDisable()}`}
              isEnabled={isActiveReview && !canDisable()}
              standard={standard}
              onReviewChange={onReviewChange}
              updatePerformanceAreasForComments={
                updatePerformanceAreasForComments
              }
              providerAgencyName={provider?.providerAgencyName}
              evaluationStatuses={[...measureEvaluationStatuses]}
              incentiveAmountCredentialing={initiativeAmount}
              canDisableDropdown={(isActiveDisputeReview && !hasDisputeQuestion([standard]))}
              CanShowDisputeIcon={(isActiveDisputeReview && hasDisputeQuestion([standard]))}
            />
          ))}
      </>
    );
  };

  const getPAEvaluationStatusCounts = (area: PerformanceArea) => {
    let statuses = [...measureEvaluationStatuses]

    let counts = statuses.filter(s => s.canShowStatus).map(status => {
      return {
        ...status,
        count: area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter(measure => {
              if (status.code === "null") {
                return (
                  measure.reviewResponse === null ||
                  measure.reviewResponse === undefined ||
                  measure.reviewResponse === "" ||
                  (typeof measure.reviewResponse === "string" &&
                    measure.reviewResponse.trim().toLowerCase() === "null")
                );
              }
              return measure.reviewResponse && measure.reviewResponse.toLowerCase() === status.code.toLowerCase();
            }).length
          );
        }, 0)
      };
    });
    // Total Initiatives per status (not used for display, just for total count)
    const totalMeasuresCount = area.standards.reduce(
      (acc, standard) => acc + standard.measures.length,
      0
    );

    return (
      <span style={{ marginLeft: 8 }}>
        <Badge
          value={`Total Initiative Programs: ${totalMeasuresCount}`}
          severity="info"
        />
        {counts.map(status => (
          <Badge
            key={status.code}
            value={`${status.name} Initiatives: ${status.count}`}
            severity={
              status.code === status.name
                ? "info"
                : status.code === "a"
                  ? "success"
                  : "warning"
            }
            className="ml-2"
          />
        ))}
      </span>
    );


  }

    const hasDisputeQuestion = (standards: Standard[]) => {
    let hasDisputeRaised: boolean = false;
    hasDisputeRaised = standards.some(
      s => s.measures.some(
        m => m.questions.some(
          q => !!q.comment || (Array.isArray(q.attachments) && q.attachments.length > 0)
        )
      )
    );
    return hasDisputeRaised;
  }

  // const renderProviderAdditionalInfo = () => {
  //   const data = [providerAdditionalInfo];
  //   return (
  //     <div>
  //       <DataTable value={data}>
  //         {Object.keys(providerAdditionalInfo).map((key) => (
  //           <Column key={key} field={key} header={key} />
  //         ))}
  //       </DataTable>
  //     </div>
  //   );
  // }

  const perfromanceAreaTabHeader = (area: PerformanceArea) => {
      const getIsCommentAvailable = (standards: Standard[]): boolean => {
        let isComments: boolean = false;
        standards.forEach((std) =>
          std.measures.forEach((measure) => {
            if (measure.isCommentsAvailable) {
              isComments = true;
            }
          })
        );
        return isComments;
      };
    const hasJustificationReasons = (standards: Standard[]): boolean => {
          let hasReasons: boolean = false;
          standards.forEach((std) =>
            std.measures.forEach((measure) => {
              if ( measure.reviewResponse?.toLowerCase() === "na") {
                hasReasons = true;
                return hasReasons
              }
            })
          );
          return hasReasons;
        };
    return (
      <div className="d-flex">
        <div
          className="d-flex"
          style={{ flexGrow: "1", justifyContent: "space-between" }}
        >
          <Tooltip target={"#pa-" + area.performanceAreaId} />
          <div
            data-pr-tooltip={area.performanceAreaTitle}
            data-pr-position="left"
            data-pr-at="right top-20"
            data-pr-my="center"
            id={area.performanceAreaId.toString()}
            className={""}
          >
            <div
              style={{
                display: "inline-block",
                maxWidth: "100ch",
                lineHeight: "2",
                textOverflow: "ellipsis",
              }}
            >
              {area.performanceAreaTitle}
              {": "}
              {area.performanceAreaDescription}
            </div>
          </div>
          {getPAEvaluationStatusCounts(area)}
        </div>
        <span style={{marginLeft: 8}}>
          {hasDisputeQuestion(area.standards) ? (
            <i
              className="pi pi-exclamation-circle"
              style={{ width: "20px", paddingTop: "5px",color:'red',fontSize:'1.2rem' }}
              title="Dispute Performance Area"
            ></i>
          ) :""}
          <Tooltip target=".pi-exclamation-circle" />
        </span>
        {hasJustificationReasons(area.standards) ? (
            <i
              className="pi pi-comments measure-not-approved-icon"
              style={{ width: "20px", paddingTop: "5px" }}
            ></i>
          ) :""}
        <div>
          {getIsCommentAvailable(area.standards) ? (
            <i
              className={"pi pi-comments"}
              style={{ width: "20px", paddingTop: "5px" }}
            ></i>
          ) : (
            <i className="pi" style={{ width: "20px", paddingTop: "5px" }}></i>
          )}
        </div>
      </div>
    );
  };

  const getTotalMeasures = () => {
    const totalMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return acc + standard.measures.length;
        }, 0)
      );
    }, 0);
    return totalMeasures;
  }

  const getApprovalPercentage = () => {
    const totalMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return acc + standard.measures.length;
        }, 0)
      );
    }, 0);

    const approvedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter((measure) => measure.reviewResponse && measure.reviewResponse.toLowerCase() != 'null').length
          );
        }, 0)
      );
    }, 0);

    const approvalPercentage =
      totalMeasures > 0 ? (approvedMeasures / totalMeasures) * 100 : 0;
    return `${approvalPercentage.toFixed(2)}% Initiatives Reviewed`;
  };

  const getCountByStatus = (statusCode: string) => {
    return performanceAreas.flatMap(area =>
      area.standards.flatMap(standard =>
        standard.measures
      )
    ).filter(measure => {
      if (statusCode === "null") {
        return !measure.reviewResponse || measure.reviewResponse.trim().toLowerCase() === "null";
      }
      return measure.reviewResponse?.toLowerCase() === statusCode.toLowerCase();
    }).length;
  };
  // const getDecisionLetter = (mpiId: string) => {
  //   console.log("getDecisionLetter:", mpiId)
  //   httpService.get(`${ApiEndpoints.GenerateDecisionLetter}/${mpiId}/${reviewYear}`)
  //     .then((response: any) => {
  //       if (response.status === 200) {
  //         console.log("Generated Decision Letter");
  //       }
  //     })
  // }
  const renderEvaluationStatusByReview = () => {
    const statuses = [...measureEvaluationStatuses];

    return (
      <div>
        <Badge
          key={'Total Initiatives'}
          value={`Total Initiatives : ${getTotalMeasures()}`}
          severity={"info"}
          className="ml-2"
        />

        {statuses &&
          statuses.length > 0 &&
          [...statuses]
            .sort((a, b) => a.name.localeCompare(b.name))
            .filter(status => status.canShowStatus)
            .map((status) => (
              <Badge
                key={status.code}
                value={`${status.name} Initiatives : ${getCountByStatus(status.code)}`}
                severity={
                  status.code === status.name
                    ? "info"
                    : status.code === "a"
                      ? "success"
                      : "warning"
                }
                className="ml-2"
              />
            ))}
      </div>
    );
  };



  // Main Accordion for Performance Areas
  const renderPerformanceAreasAccordion = () => {
    // console.log("Rendering Performance Areas Accordion", performanceAreas);
    return (
      <>
        <div>
          <div className="evaluation-info-container">
            <h3>
              <span className="section-title">Performance Evaluation</span>

              <Badge
                value={getApprovalPercentage()}
                severity={
                  getApprovalPercentage()?.includes("100") ? "success" : "info"
                }
                className="ml-2"
              />
            </h3>

            {renderEvaluationStatusByReview()}

          </div>
          <Accordion>
            {performanceAreas
              .sort((a, b) =>
                alphaNumericSort(
                  a.performanceAreaTitle,
                  b?.performanceAreaTitle
                )
              )
              .map((area) => (
                <AccordionTab
                  key={area.performanceAreaTitle}
                  header={perfromanceAreaTabHeader(area)}
                >
                  {renderStandardsSection(area.standards, area.performanceAreaId)}
                </AccordionTab>
              ))}
          </Accordion>
        </div>
      </>
    );
  };

  // Callback function for successful file upload
  const handleUploadSuccess = () => {
    setUploadStatus("File uploaded successfully");
    setFileUploaded(true); // Trigger file upload state change
  };

  const renderTierView = () => {
    return (
      <div className="tier-view-accordion">
        {loading ? (
          <p>Loading performance areas...</p>
        ) : (
          renderPerformanceAreasAccordion()
        )}
      </div>
    );
  };

  const downloadDataFile = (fileName: any, providerId: any) => {
    const safeProviderId = Number(providerId);
    if (!safeProviderId || !Number.isInteger(safeProviderId) || safeProviderId <= 0) {
      console.error("Invalid provider ID");
      return;
    }
    httpService
      .get(
        `${ApiEndpoints.DownloadSupportingDataFile}/${safeProviderId}/${encodeURIComponent(String(fileName))}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        if (response) {
          console.log("response", response);
          let url = response.data.url;
          const validatedUrl = new URL(url);
          if (
            validatedUrl.protocol === "http:" ||
            validatedUrl.protocol === "https:"
          ) {
            const anchor = document.createElement("a");
            anchor.href = validatedUrl.toString();
            anchor.target = "_blank";
            anchor.click();
          }
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
        setShowConfirmDialog(true);
      })
      .finally(() => {
        //setShowConfirmDialog(false);
      });
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const hideDialog = () => {
    setShowConfirmDialog(false);
  };
  const StartReview = () => {
    httpService
      .get(`${ApiEndpoints.PfpStartReview}/${reviewYear}/${provider.mpi}`)
      .then((response: any) => {
        if (response) {
          console.log("response", response);
          setCanStartReview(false);
          getReviewersDetails(provider.mpi);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  }
  const renderReviewersDetails = () => {
    return (
      <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <ReviewersDetailsComponent reviewers={reviewers} />
      </div>
    );
  };
  return (
    <div className="provider-profile-file-upload">

      {provider && <div style={{ display: "flex", flexDirection: "row", columnGap: "2rem" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="flex-gap-bottom">
            <span className="tag-key"><strong>Agency Name :</strong></span>
            {provider?.providerAgencyName?.length > 40 ? (
              <>
                <span
                  className="tag-value agency-name-ellipsis"
                  data-pr-tooltip={provider?.providerAgencyName}
                >
                  {" "}
                  {provider?.providerAgencyName}
                </span>{" "}
                <Tooltip target=".agency-name-ellipsis" />
              </>
            ) : (
              <span className="tag-value"> {provider?.providerAgencyName}</span>
            )}
            <span className="tag-key"><strong>MPI</strong> :</span>
            <span className="tag-value"> {provider.mpi}</span>
          </div>
          <div className="flex-gap-bottom">
            <span className="tag-key"><strong>Review Status :</strong></span>
            {status.length > 0 && (
              <Dropdown
                disabled={
                  !isActiveReview ||
                  isAdministrator() ||
                  canDisableStatusRelatedInputs() ||
                  isReadOnlyForFinalReviewer()
                }
                value={selectedStatus}
                onChange={(e: DropdownChangeEvent) => setReviewStatus(e.value)}
                options={status.sort((a, b) =>
                  b.statusName.localeCompare(a.statusName)
                )}
                optionLabel="statusName"
                placeholder={provider.reviewStatus}
              />
            )}
            {canStartReview && status.length > 0 && (
              <Button
                label="Start Review"
                className="p-button-info ml-2"
                onClick={() => StartReview()}
              />
            )}
          </div>
          {credentialingOutcomeStatus && (
            <div className="flex-gap-bottom">
              <span className="tag-key"><strong>Approval Status: Credentialing:</strong></span>
              <span className="tag-value">{resetApprovalStatus || (isAdministrator() && (provider.reviewStatusCode == ReviewStatusCode.ScoReviewCompleted || provider.reviewStatusCode == ReviewStatusCode.ScoPfpResolutionReviewCompleted )) ? credentialingOutcomeStatus: "Unassigned"}</span>
            </div>)}
          {technologyOutcomeStatus && (
            <div className="flex-gap-bottom">
              <span className="tag-key"><strong>Approval Status: Technology:</strong></span>
              <span className="tag-value">{resetApprovalStatus || (isAdministrator() && provider.reviewStatusCode == ReviewStatusCode.ScoReviewCompleted || provider.reviewStatusCode.toLowerCase() == ReviewStatusCode.ScoPfpResolutionReviewCompleted.toLowerCase()) ? technologyOutcomeStatus : "Unassigned"}</span>
            </div>
          )}
        </div>
        <div>
          {reviewers && reviewers.length > 0 && renderReviewersDetails()}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginLeft: "auto",
          }}
        >
          <Button
            size="small"
            className="p-button-secondary"
            disabled={!isActiveReview}
            onClick={() => setSidebarVisible(!sidebarVisible)}
            style={{ marginRight: "15px" }}
          >
            Comment
          </Button>
          {/* <Button
            size="small"
            disabled={isAdministrator() || canDisableStatusRelatedInputs()}
            className="p-button-secondary"
            onClick={() => setVisible(true)}
            style={{ marginRight: "15px" }}
          >
            Upload File
          </Button> */}
        </div>
      </div>
      }
      <Dialog
        header="Upload"
        visible={visible}
        onHide={() => setVisible(false)}
      >
        <div
          className="flex flex-column px-8 py-5 gap-4"
          style={{
            borderRadius: "12px",
            width: "1000px",
            height: "auto",
            minHeight: "300px",
          }}
        >
          {provider.providerId && (
            <MultipartFileUploadComponent
              name="file"
              customUpload
              accept=".pdf,.doc,.docx"
              maxFileSize={1000000}
              auto
              chooseLabel="Choose"
              uploadLabel="Upload"
              cancelLabel="Cancel"
              className="p-mb-3"
              onFileuploaded={() => {
                console.log("file uploaded");
              }}
              providerId={provider.mpi}
              providerProfile="ProviderProfile"
              onUpload={handleUploadSuccess}
              onError={() => {
                setUploadStatus("Upload failed. Please try again.");
              }}
            />
          )}
          {uploadStatus && <p>{uploadStatus}</p>}
        </div>
      </Dialog>

      <div>
        <h3>
          <span className="section-title">SCO Demographic Information</span>
        </h3>
        {loading ? (
          <p>Loading provider details...</p>
        ) : (
          <DataTable value={[provider]} paginator={false}>
            <Column field="firstName" header="First Name" />
            <Column field="lastName" header="Last Name" />
            <Column field="telephoneNumber" header="Phone Number" />
            <Column
              field="emailAddress"
              header="Email Address"
              body={(rowData) => (
                <a href={`mailto:${rowData.emailAddress}`}>
                  {rowData.emailAddress}
                </a>
              )}
            />
            <Column field="scoRevenue" header="SCO Revenue" />
          </DataTable>
        )}
        <br></br>
      </div>
      {provider.attestationFile ? (
        <div className="attestation-button-wrapper">
          <Button
            onClick={() => {
              downloadDataFile(provider.attestationFile, provider?.mpi);
            }}
            icon="pi pi-download"
            className="p-button-secondary"
          >
            &nbsp;{provider.attestationFile}
            {/*"Download Attestation File"*/}
          </Button>
        </div>
      ) : (
        <></>
      )}

      <div>{renderTierView()}</div>
      <Dialog
        header="File not found!"
        visible={showConfirmDialog}
        onHide={hideDialog}
        footer={
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              label="Close"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideDialog}
              autoFocus
            />
          </div>
        }
      >
        <div>
          <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
        </div>
      </Dialog>
      {sidebarVisible && (
        <CommentsSidebar
          {...{
            sidebarVisible,
            setSidebarVisible,
            commentProviderMPI,
            commentMeasureId,
            commentMeasureNumber,
            commentLevel,
            updatePerformanceAreasForComments,
            providerAgencyName: provider?.providerAgencyName,
          }}
        />
      )}


      {/* <JustificationDialog
        header="Rationale for “Fail” Determination​"
        message={`Please provide your reasoning below for why this SCO does not qualify for the “${commentMeasureNumber}” initiative program. Select as many reasons as are applicable and provide a written explanation of your reasoning.`}
        style={{ width: "50vw" }}
        visible={reasonDialogVisible}
        onHide={() => setReasonDialogVisible(false)}
        isReadOnly={false}
        reasons={reviewReasons}
        selectedReasonIds={selectedReasonIds.map((reasonId: any) => reasonId)}
        userReason={userReason}
        onReasonChange={onReasonChange}
        onUserReasonChange={setUserReason}
        onSave={saveFailedReviewResponse}
      /> */}
      <CommonDialogWindowComponent ref={dialogRef} />
    </div>
  );
};

export default PfpScoProviderProfileComponent;
